import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CheckItem } from './ui/CheckItem';
import { sinSistema, conSistema } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function TransformationSection() {
  return <section className="bg-mp-black py-16 md:py-24" data-id="element-299" data-mp="2nxhbd9u54916">
      <Container data-id="element-300" data-mp="2nz23ksszffvv">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-301" data-mp="2j68yu4xik7js">
          <SectionTag tone="lime" data-id="element-302" data-mp="2j4o68kureyok">El cambio real</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-303" data-mp="2e6mn5zxc2zd3">
            De improvisar cada semana a trabajar con un sistema.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6" data-id="element-304" data-mp="249hvjkkpybow">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="rounded-2xl border border-mp-border bg-mp-dark p-7" data-id="element-305" data-mp="207d3urdtzp4w">
            <p className="font-heading text-sm uppercase tracking-[0.15em] text-mp-gray" data-id="element-306" data-mp="5deokgb1ilvh">Sin un sistema</p>
            <ul className="mt-5 space-y-3" data-id="element-307" data-mp="abg2ynxitx0m">
              {sinSistema.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-308" data-mp="y1tri4gwddqg">
                  <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-mp-gray/60" strokeWidth={2.5} data-id="element-309" data-mp="xzr13jbu1il7" />
                  <span className="text-sm text-mp-gray/80 md:text-[15px]" data-id="element-310" data-mp="12yaprrht98h9">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="rounded-2xl border border-mp-lime/40 bg-mp-card p-7 shadow-glow-lime" data-id="element-311" data-mp="t15xrb1aaisj">
            <p className="font-heading text-sm uppercase tracking-[0.15em] text-mp-lime" data-id="element-312" data-mp="1faw9cpu91bfj">Con Maestro en Pista</p>
            <ul className="mt-5 space-y-3" data-id="element-313" data-mp="1ajwerr8lr5g7">
              {conSistema.map(item => <CheckItem key={item} data-id="element-314" data-mp="15l2y5py0qybt">{item}</CheckItem>)}
            </ul>
          </motion.div>
        </div>
      </Container>
    </section>;
}